var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"pt3 mb3 align--center"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.headline))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"m0",attrs:{"title":"Chefy"}},[_c('img',{staticClass:"logo mb1 pl1 pr1",attrs:{"src":require("../assets/logo.svg"),"alt":"Chefy"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e4bf9dd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 20
// module chunks = 0